var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M10.6687 6.00115C10.6687 3.42333 8.57898 1.33359 6.00115 1.33359C3.42333 1.33359 1.33359 3.42333 1.33359 6.00115C1.33359 8.57898 3.42333 10.6687 6.00115 10.6687C8.57898 10.6687 10.6687 8.57898 10.6687 6.00115ZM12.0023 6.00115C12.0023 7.41807 11.5101 8.71938 10.6889 9.74601L13.1405 12.1977C13.4009 12.4581 13.4009 12.8802 13.1405 13.1405C12.8801 13.4009 12.458 13.4009 12.1977 13.1405L9.74601 10.6889C8.71938 11.5101 7.41807 12.0023 6.00115 12.0023C2.68681 12.0023 0 9.3155 0 6.00115C0 2.68681 2.68681 0 6.00115 0C9.3155 0 12.0023 2.68681 12.0023 6.00115Z",
          fill: _vm.fill
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }